import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  EmbeddedViewRef,
  inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { SbPageActionService } from '../../../services/page-action/sb-page-action.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
@Component({
  selector: 'sb-page-action',
  templateUrl: './sb-page-action.component.html',
  standalone: false,
})
export class SbPageActionComponent implements AfterViewInit {
  private readonly pageActionService = inject(SbPageActionService);
  private readonly cdRef = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);
  // private readonly router = inject(Router);

  @ViewChild('pageActionVCR', { read: ViewContainerRef, static: true }) pageActionVCR!: ViewContainerRef;

  currentPageAction: EmbeddedViewRef<any>[] = [];

  ngAfterViewInit(): void {
    // Subscribe to get all actions
    this.pageActionService.actions$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe({
      next: actions => {
        // clear/destroy existing actions
        this.currentPageAction.forEach(v => v.destroy());
        this.currentPageAction = [];
        this.pageActionVCR.clear();

        // create new after clearing completed
        actions.forEach(action => {
          const view = this.pageActionVCR.createEmbeddedView(action);
          this.currentPageAction.push(view);
        });

        this.cdRef.detectChanges();
      },
    });

    /*
    // Clear on navigation start (optional: only if you want fresh start)
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(event => {
      if (event instanceof NavigationStart) {
        this.pageActionService.clearAll();
      }
    });

     */
  }
}
